module.exports = __webpack_public_path__ + "img/20 clase.a5758c00.jpg";